<template>
<main class="bg-main lesson-quiz lesson-multiaudio">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>

  <section class="container">

     <div class="heading-content-title">{{ $t('lesson.introduction.title') }}</div>
     
      <lessonmultiaudio v-if="introductionData.content.slide && audioType" :audioList="introductionData.content.slide" :audioType="audioType" @playevent="audioPlayEvent"></lessonmultiaudio>
    
      <div class="buttons-side-by-side">
        <a class="button button-default back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

  </section>

</main>

</template>

<script>

import {appEnv, useCoachmark} from './../../config';

import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'

import componentContentHead from '../shared/ContentHead.vue';

import LessonMultiAudio from './LessonMultiAudio.vue'


import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

  export default {
    name: 'LessonIntroduction',
    mixins: [
      learningLog,
      status
    ],
    components: {
      'contenthead': componentContentHead,
      'lessonmultiaudio': LessonMultiAudio,
    },
    data () {
      return {
        step: 'introduction',
        audioType: 'slide',
        authUser: null,
        driver: null,
        storage: {}
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      introductionData() {
        return this.$store.getters.lesson_content.introduction ? this.$store.getters.lesson_content.introduction : {content: { title: '', body: ''}}
      },
    },
    created() {
      
      this.authUser = this.$store.getters.getAuthUser;
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
    },
    mounted() {
      
      if(useCoachmark) {
        this.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
        
        const isCoachmarkDone = this.storage.getItem("coachmarkdone") ? JSON.parse(this.storage.getItem("coachmarkdone")) : null;
        if(!(isCoachmarkDone && this.step in isCoachmarkDone && isCoachmarkDone[this.step])) {
          this.showCoachMark();
        }
      }
    },
    methods: {
      nextStep() {
        if (this.$store.getters.lesson_content[this.step].status != 'completed') {
          this.statusContent('completed', this.step);
          this.$store.dispatch('updateLessonContentStatus', {type: 'introduction', status: 'completed' });
        }
        this.learningTempLog();
        this.learningLog();
        
        this.$router.push({name: 'lesson.grammar'});
      },
      back() {
        this.$router.push({ name: 'region', params: { region: this.$store.getters.section_data.section } });
      },
      audioPlayEvent: function(value) {
        if(this.driver) {
          this.driver.reset();
        }
      },
      initCoachMark() {
        if(this.driver) {
          this.driver.reset()
        } else {
          const driverOverlay = document.getElementById('driver-page-overlay')
          const driverStage = document.getElementById('driver-highlighted-element-stage')
          const driverItem = document.getElementById('driver-popover-item')
          const driverItem2 = document.getElementById('driver-popover-item2')
          
          if(driverOverlay) {
            driverOverlay.remove()
          }
          if(driverStage) {
            driverStage.remove()
          }
          if(driverItem) {
            driverItem.remove()
          }
        }
      },
      showCoachMark() {
        let self = this
        if(!this.authUser) return false;

         this.driver = new Driver({
            className: "scoped-class-dark",
            animate: true,
            opacity: 0.7,
            padding: 10,
            stageBackground: 'rgb(255, 255, 255)',
            allowClose: true,
            overlayClickNext: false,
            DoneBtnText: "Done",
            CloseBtnText: "Close",
            NextBtnText: "Next",
            PrevBtnText: "Previous step",
            onReset: (e) => {
            
              let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
              if(!coachMarks) {
                coachMarks = {};
                coachMarks[this.step] = true;
              } else {
                coachMarks[this.step] = true;
              }

              this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
            }
        })
        setTimeout(() => {
          this.driver.highlight({
            element: '.buttons-audio',
            popover: {
              className: 'popover-class',
              title: 'click to Play',
              position: 'top',
            }
          })
        })
      }
    },
  }
</script>

<style scoped>
@media screen and (max-width: 900px) {
  .maxWidth {
    width: 100%;
  }
}
</style>
